import React from 'react';
interface Section {
  heading: string;
  content: React.ReactNode;
}
const intro = 'En Real en línea, respetamos tu privacidad y estamos comprometidos con la protección de tus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información cuando visitas nuestro sitio web, interactúas con nuestras páginas, anuncios, formularios o realizas una compra de nuestros productos o servicios.';
const sections: Section[] = [{
  heading: '1. Información que recopilamos',
  content: <>
        <p data-id="element-65">Podemos recopilar información personal cuando:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-66">
          <li data-id="element-67">visitas nuestro sitio web,</li>
          <li data-id="element-68">completas formularios,</li>
          <li data-id="element-69">solicitas información,</li>
          <li data-id="element-70">te registras para recibir contenido,</li>
          <li data-id="element-71">
            interactúas con nuestros anuncios en Facebook, Instagram u otras
            plataformas,
          </li>
          <li data-id="element-72">realizas una compra,</li>
          <li data-id="element-73">
            o te comunicas con nosotros por correo electrónico, redes sociales,
            WhatsApp u otros medios.
          </li>
        </ul>
        <p className="mt-4" data-id="element-74">La información recopilada puede incluir:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-75">
          <li data-id="element-76">nombre y apellidos,</li>
          <li data-id="element-77">dirección de correo electrónico,</li>
          <li data-id="element-78">número de teléfono,</li>
          <li data-id="element-79">país o ciudad,</li>
          <li data-id="element-80">dirección IP,</li>
          <li data-id="element-81">información de navegación,</li>
          <li data-id="element-82">
            datos relacionados con compras, pagos o interés en nuestros
            productos o servicios.
          </li>
        </ul>
      </>
}, {
  heading: '2. Cómo utilizamos tu información',
  content: <>
        <p data-id="element-83">Utilizamos la información recopilada para:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-84">
          <li data-id="element-85">responder a tus consultas o solicitudes,</li>
          <li data-id="element-86">
            enviarte información sobre productos, servicios, promociones o
            contenidos,
          </li>
          <li data-id="element-87">procesar compras y pagos,</li>
          <li data-id="element-88">gestionar el acceso a productos digitales,</li>
          <li data-id="element-89">
            mejorar nuestro sitio web, campañas, contenidos y experiencia del
            usuario,
          </li>
          <li data-id="element-90">analizar resultados publicitarios,</li>
          <li data-id="element-91">personalizar anuncios y comunicaciones,</li>
          <li data-id="element-92">cumplir obligaciones legales o contractuales.</li>
        </ul>
      </>
}, {
  heading: '3. Cookies y tecnologías de seguimiento',
  content: <>
        <p data-id="element-93">
          Nuestro sitio web puede utilizar cookies, píxeles, etiquetas y
          tecnologías similares para mejorar la experiencia del usuario,
          analizar la navegación y medir el rendimiento de nuestras campañas
          publicitarias.
        </p>
        <p className="mt-4" data-id="element-94">Esto puede incluir herramientas como:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-95">
          <li data-id="element-96">Meta Pixel (antes Facebook Pixel)</li>
          <li data-id="element-97">cookies del navegador</li>
          <li data-id="element-98">herramientas de analítica</li>
          <li data-id="element-99">tecnologías de seguimiento de conversiones</li>
        </ul>
        <p className="mt-4" data-id="element-100">
          Estas herramientas pueden recopilar información como:
        </p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-101">
          <li data-id="element-102">páginas visitadas,</li>
          <li data-id="element-103">tiempo de navegación,</li>
          <li data-id="element-104">acciones realizadas dentro del sitio,</li>
          <li data-id="element-105">tipo de dispositivo,</li>
          <li data-id="element-106">navegador utilizado,</li>
          <li data-id="element-107">dirección IP,</li>
          <li data-id="element-108">interacciones con anuncios o formularios.</li>
        </ul>
      </>
}, {
  heading: '4. Publicidad y remarketing',
  content: <>
        <p data-id="element-109">
          Podemos utilizar la información recopilada para mostrar anuncios
          personalizados o realizar campañas de remarketing en plataformas como
          Facebook, Instagram u otras redes publicitarias.
        </p>
        <p className="mt-4" data-id="element-110">
          Esto nos permite medir resultados, optimizar campañas y ofrecer
          contenido más relevante a nuestros usuarios.
        </p>
      </>
}, {
  heading: '5. Procesamiento de pagos y terceros',
  content: <>
        <p data-id="element-111">
          Algunas compras o registros pueden procesarse a través de plataformas
          de terceros, incluyendo, pero no limitado a, Hotmart y otras
          herramientas tecnológicas utilizadas para pagos, automatización,
          analítica, email marketing, alojamiento web o publicidad digital.
        </p>
        <p className="mt-4" data-id="element-112">
          Estas plataformas pueden recopilar y procesar cierta información de
          acuerdo con sus propios términos y políticas de privacidad.
        </p>
      </>
}, {
  heading: '6. Compartición de información',
  content: <p data-id="element-113">
        En Real en línea no vendemos, alquilamos ni comercializamos tus datos
        personales. Sin embargo, podemos compartir información con proveedores o
        servicios de terceros que nos ayudan a operar el sitio web, procesar
        pagos, entregar productos, analizar métricas o ejecutar campañas
        publicitarias, siempre dentro de lo necesario para el funcionamiento del
        negocio.
      </p>
}, {
  heading: '7. Conservación de los datos',
  content: <p data-id="element-114">
        Conservaremos tu información personal durante el tiempo que sea
        necesario para cumplir con los fines descritos en esta Política de
        Privacidad, salvo que la ley exija o permita un periodo mayor.
      </p>
}, {
  heading: '8. Seguridad de la información',
  content: <p data-id="element-115">
        Tomamos medidas razonables de seguridad para proteger tu información
        frente a pérdida, uso indebido, acceso no autorizado, alteración o
        divulgación. Sin embargo, ningún sistema de transmisión o almacenamiento
        de datos en internet es completamente seguro, por lo que no podemos
        garantizar una seguridad absoluta.
      </p>
}, {
  heading: '9. Tus derechos',
  content: <>
        <p data-id="element-116">Dependiendo de tu país o jurisdicción, puedes tener derecho a:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-117">
          <li data-id="element-118">acceder a tus datos personales,</li>
          <li data-id="element-119">solicitar la corrección de información inexacta,</li>
          <li data-id="element-120">solicitar la eliminación de tus datos,</li>
          <li data-id="element-121">oponerte a determinados usos de tu información,</li>
          <li data-id="element-122">retirar tu consentimiento cuando sea aplicable.</li>
        </ul>
        <p className="mt-4" data-id="element-123">
          Si deseas ejercer cualquiera de estos derechos, puedes contactarnos a
          través del correo indicado al final de esta política.
        </p>
      </>
}, {
  heading: '10. Enlaces a sitios externos',
  content: <p data-id="element-124">
        Nuestro sitio web puede contener enlaces a sitios web de terceros. No
        somos responsables por las políticas de privacidad, contenidos o
        prácticas de dichos sitios externos.
      </p>
}, {
  heading: '11. Cambios a esta política',
  content: <p data-id="element-125">
        Nos reservamos el derecho de actualizar o modificar esta Política de
        Privacidad en cualquier momento. Cualquier cambio será publicado en esta
        misma página y entrará en vigor desde su fecha de publicación.
      </p>
}, {
  heading: '12. Contacto',
  content: <>
        <p data-id="element-126">
          Si tienes preguntas sobre esta Política de Privacidad o sobre el
          tratamiento de tus datos, puedes contactarnos en:
        </p>
        <dl className="mt-4 space-y-2" data-id="element-127">
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-128">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-129">Marca:</dt>
            <dd data-id="element-130">Real en línea</dd>
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-131">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-132">Sitio web:</dt>
            <dd data-id="element-133">realenlinea.com</dd>
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-134">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-135">
              Correo electrónico:
            </dt>
            <dd data-id="element-136">
              <a href="mailto:realenlinea1@gmail.com" className="underline underline-offset-2 hover:text-neutral-900 transition-colors" data-id="element-137">
                realenlinea1@gmail.com
              </a>
            </dd>
          </div>
        </dl>
      </>
}];
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-white text-neutral-900 flex flex-col" data-id="element-138">
      <header className="border-b border-neutral-200" data-id="element-139">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-140">
          <a href="/" className="text-lg font-semibold tracking-tight" data-id="element-141">
            Real en línea
          </a>
          <nav className="text-sm text-neutral-600" data-id="element-142">
            <a href="/" className="hover:text-neutral-900 transition-colors" data-id="element-143">
              Inicio
            </a>
          </nav>
        </div>
      </header>

      <main className="flex-1" data-id="element-144">
        <article className="max-w-3xl mx-auto px-6 py-16" data-id="element-145">
          <div className="mb-12" data-id="element-146">
            <p className="text-sm uppercase tracking-wider text-neutral-500 mb-3" data-id="element-147">
              Legal
            </p>
            <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4" data-id="element-148">
              Política de Privacidad
            </h1>
            <p className="text-neutral-600" data-id="element-149">
              Última actualización: 10 de mayo de 2026
            </p>
          </div>

          <section className="mb-12" data-id="element-150">
            <p className="text-neutral-700 leading-relaxed" data-id="element-151">{intro}</p>
          </section>

          <div className="space-y-12" data-id="element-152">
            {sections.map(section => <section key={section.heading} data-id="element-153">
                <h2 className="text-xl font-semibold tracking-tight mb-4" data-id="element-154">
                  {section.heading}
                </h2>
                <div className="text-neutral-700 leading-relaxed space-y-2" data-id="element-155">
                  {section.content}
                </div>
              </section>)}
          </div>
        </article>
      </main>

      <footer className="border-t border-neutral-200" data-id="element-156">
        <div className="max-w-3xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-neutral-600" data-id="element-157">
          <p data-id="element-158">
            © {new Date().getFullYear()} Real en línea. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-159">
            <a href="/" className="hover:text-neutral-900 transition-colors" data-id="element-160">
              Inicio
            </a>
            <a href="/privacidad" className="hover:text-neutral-900 transition-colors" data-id="element-161">
              Privacidad
            </a>
          </div>
        </div>
      </footer>
    </div>;
}